import { useEffect } from 'react';

/**
 * @deprecated: use react-use's useClickAway instead
 * https://github.com/streamich/react-use/blob/master/docs/useClickAway.md
 * */
export const useClickOutside = (wrapperRef, func) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!wrapperRef.current?.contains(event.target)) {
        func(event);
      }
    };

    // Bind the click outside event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  });
};
